import { render, staticRenderFns } from "./SendInvitationAsConsultantModal.vue?vue&type=template&id=f8b5a16a"
import script from "./SendInvitationAsConsultantModal.vue?vue&type=script&lang=js"
export * from "./SendInvitationAsConsultantModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8b5a16a')) {
      api.createRecord('f8b5a16a', component.options)
    } else {
      api.reload('f8b5a16a', component.options)
    }
    module.hot.accept("./SendInvitationAsConsultantModal.vue?vue&type=template&id=f8b5a16a", function () {
      api.rerender('f8b5a16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/SendInvitationAsConsultantModal.vue"
export default component.exports